import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ReSendFilesContractWidget from '../../../widgets/attachfiles/ReSendFilesContractWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getContractAttachment, getContractSubmitForm, getSendFileToESignPage } from '../../../redux/actions/contract'
import CenterOfferAuthorizedSignatoryStaffPanel from '../../../widgets/centerOfferAuthorizedSignatoryStaff/CenterOfferAuthorizedSignatoryStaffPanel'
import ContractSigningWidgets from '../../../widgets/ContractSigning/ContractSigningWidgets'
import { ERR_MSG, RETRY_CONTACT_ADMIN } from '../../../constants/msgText'
import notification from '../../../utils/notification'
import { getAllAttachments } from '../../../redux/actions/attachments'
import AttachFilesDocWidget from '../../../widgets/attachfiles/AttachFilesDocWidget'

export default function ReSendFile() {
  //ส่งเอกสารใหม่
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [contractSubmitFormSchema, setContractSubmitFormSchema] = useState()

  const [ESignFilesSchema, setESignFilesSchema] = useState()

  useEffect(() => {
    projectId && handleGetSchema(projectId)
    projectId && handleGetESignFileSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getSendFileToESignPage(projectVersionId)
      // console.log('response => ', response)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }


  const handleGetESignFileSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getAllAttachments(projectId)
      setESignFilesSchema(_schema?.forms?.contract)
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || `${ERR_MSG} ${RETRY_CONTACT_ADMIN}`,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />
        {schema && (
          <>
            {schema?.forms?.contractFilesToESign && (
              <>
                <ReSendFilesContractWidget
                  schema={schema.forms.contractFilesToESign}
                  isContractCenter={true}
                />
              </>
            )}

            <br />

            {ESignFilesSchema && (
              <>
                <AttachFilesDocWidget
                  schema={ESignFilesSchema}
                  header={'รายการเอกสารจากระบบลงนามอิเล็กทรอนิกส์'}
                  
                />
                <br />
              </>
            )}
          </>
        )}
        <br />
      </SidebarProposal>
    </>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  model: {
    header: 'ตรวจสอบเอกสารประกอบการทำสัญญา',
    subHeader: null,
    forms: {
      contractFilesToESign: {
        header: 'รายการไฟล์ที่ส่งไปยังระบบลงนามอิเล็กทรอนิกส์',
        values: [
          {
            id: '9A7D7D30-3937-4897-A7CA-12C1FC49F957',
            projectCode: '66-00055',
            masterContractFileId: null,
            masterContractFileName: null,
            attachmentTypeId: 0,
            fileLabel: 'econtract_ข้อเสนอโครงการ_66-00055_v.5.0',
            fileName: 'econtract_ข้อเสนอโครงการ_66-00055_v.5.0',
            filePath: 'files/proposal/57A36412-47C7-4306-8B1F-7F29483E7B68.pdf',
            sendStatus: 1,
            sendStatusName: 'ส่งสำเร็จ',
          },
          {
            id: 'C6236A28-015D-4295-8ACD-94CC7B61D8A4',
            projectCode: '66-00055',
            masterContractFileId: '50',
            masterContractFileName: 'กฎหมาย กฎกระทรวง ข้อบังคับ หรือกฎระเบียบที่จัดตั้งหน่วยงาน',
            attachmentTypeId: 0,
            fileLabel: 'Screenshot 2566-11-21 at 10.47.45.png',
            fileName: 'Screenshot 2566-11-21 at 10.47.45.png',
            filePath: 'proposal/person-qualification/4890B78F-FA09-460C-92B1-D2226B3075A0.png',
            sendStatus: 2,
            sendStatusName: 'ส่งไม่สำเร็จ',
          },
          {
            id: 'F51C6E57-FABA-40B0-ADA2-98E7EBC51244',
            projectCode: '66-00055',
            masterContractFileId: '200',
            masterContractFileName: 'เอกสารคุณสมบัติผู้รับผิดชอบโครงการ',
            attachmentTypeId: 0,
            fileLabel: 'Screenshot 2566-11-07 at 14.22.49.png',
            fileName: 'Screenshot 2566-11-07 at 14.22.49.png',
            filePath: 'proposal/person-qualification/4B082918-AC68-41D9-96A6-EF2FFF0C03D2.png',
            sendStatus: 2,
            sendStatusName: 'ส่งไม่สำเร็จ',
          },
          {
            id: '9CB6FDC5-8299-4C84-914B-A287569BE044',
            projectCode: '66-00055',
            masterContractFileId: '51',
            masterContractFileName:
              'สำเนาคำสั่งแต่งตั้งผู้มีอำนาจกระทำการแทนหน่วยงานนั้น พร้อมรับรองสำเนา',
            attachmentTypeId: 0,
            fileLabel: 'examplePDF.pdf',
            fileName: 'examplePDF.pdf',
            filePath: 'proposal/person-qualification/C15EC836-FC70-46A8-A176-B8E5C8251317.pdf',
            sendStatus: 1,
            sendStatusName: 'ส่งสำเร็จ',
          },
          {
            id: 'E0D3C6A9-DD1C-460C-999D-6B35AD4899C8',
            projectCode: '66-00055',
            masterContractFileId: '52',
            masterContractFileName:
              'สำเนาบัตรประจำตัวประชาชนหรือบัตรอื่นที่ทางราชการออกให้แก่ผู้มีอำนาจกระทำการแทนหน่วยงานนั้น และหลักฐานการเปลี่ยนชื่อตัวหรือชื่อสกุล (ถ้ามี) พร้อมรับรองสำเนา',
            attachmentTypeId: 0,
            fileLabel: 'เอกสารแนบประกาศ_FC01.pdf',
            fileName: 'เอกสารแนบประกาศ_FC01.pdf',
            filePath: 'proposal/person-qualification/22E6C79F-7EB7-47DF-A2F1-FA60F2810803.pdf',
            sendStatus: 1,
            sendStatusName: 'ส่งสำเร็จ',
          },
          {
            id: '27259684-D863-4713-AAE3-CD9D7C1C08DE',
            projectCode: '66-00055',
            masterContractFileId: '53',
            masterContractFileName:
              'หนังสือมอบอำนาจที่ระบุว่า “มอบอำนาจให้ผู้ใดมีอำนาจลงนามข้อตกลงรับทุน และกระทำการแทนหน่วยงานนั้น” และสำเนาบัตรประจำตัวประชาชนหรือบัตรอื่นที่ทางราชการออกให้แก่ผู้รับมอบอำนาจ พร้อมรับรองสำเนา (ถ้ามี)',
            attachmentTypeId: 0,
            fileLabel: 'ถอดบทเรียนโครงการโรงเรียนบ้านปางกอม.pdf',
            fileName: 'ถอดบทเรียนโครงการโรงเรียนบ้านปางกอม.pdf',
            filePath: 'proposal/person-qualification/3E9B8FB6-DEA5-46F9-8661-6E54095529E8.pdf',
            sendStatus: 1,
            sendStatusName: 'ส่งสำเร็จ',
          },
          {
            id: '8251187A-DDD5-4A3E-A973-C1281992E647',
            projectCode: '66-00055',
            masterContractFileId: '54',
            masterContractFileName:
              'สำเนาใบทะเบียนภาษีมูลค่าเพิ่ม (แบบ ภ.พ. 20) หรือใบแทนใบทะเบียนภาษีมูลค่าเพิ่มที่สำนักงานสรรพากรพื้นที่ออกให้ (กรณีที่ใบทะเบียนภาษีมูลค่าเพิ่มสูญหาย หรือถูกทำลาย หรือชำรุดในสาระสำคัญ) เฉพาะกรณีที่ผู้รับทุนต้องการเรียกเก็บภาษีมูลค่าเพิ่ม',
            attachmentTypeId: 0,
            fileLabel: 'Screenshot 2566-07-03 at 19.26.44.png',
            fileName: 'Screenshot 2566-07-03 at 19.26.44.png',
            filePath: 'proposal/person-qualification/A015D7DC-FF78-45AD-90CB-49201584B02F.png',
            sendStatus: 2,
            sendStatusName: 'ส่งไม่สำเร็จ',
          },
        ],
      },
      // contractFilesFromESign: {
      //   header: 'รายการเอกสารจากระบบลงนามอิเล็กทรอนิกส์',
      //   values: [
      //     {
      //       contractFileTypeId: null,
      //       contractFileType: null,
      //       uploadDate: null,
      //       isChecked: false,
      //       enableDelete: false,
      //       isRequired: false,
      //       label: 'ข้อเสนอโครงการ',
      //       name: 'proposal',
      //       path: 'files/proposal/9A969F19-91C5-4394-B492-14D0B280A7CB.pdf',
      //       type: null,
      //       size: 0,
      //       id: '0575B154-80EC-4C08-9C4B-B216E1FAFF0F',
      //     },
      //     {
      //       contractFileTypeId: null,
      //       contractFileType: null,
      //       uploadDate: null,
      //       isChecked: false,
      //       enableDelete: false,
      //       isRequired: false,
      //       label: 'สัญญา',
      //       name: 'contract',
      //       path: 'files/contract/C399C4E9-051C-4BBE-B069-24B7A9213F02.pdf',
      //       type: null,
      //       size: 0,
      //       id: '7763FB2E-65D3-41D8-9267-B1DC0B8BB1BC',
      //     },
      //     {
      //       contractFileTypeId: '10',
      //       contractFileType:
      //         'สำเนาบัตรประจำตัวประชาชนหรือบัตรอื่นที่ทางราชการออกให้ พร้อมรับรองสำเนา',
      //       uploadDate: '2023-10-04T21:08:56.1',
      //       isChecked: true,
      //       enableDelete: true,
      //       isRequired: true,
      //       label: 'example.pdf',
      //       name: 'example.pdf',
      //       path: 'proposal/person-qualification/460E2D35-AB30-43FC-BB90-4038C347916E.pdf',
      //       type: null,
      //       size: 0,
      //       status: 'ส่งแล้ว',
      //       id: '2E6B7528-EBAE-413B-9ADD-9AB0E9DD63EF',
      //     },
      //     {
      //       contractFileTypeId: '12',
      //       contractFileType:
      //         'กรณีผู้รับทุนเป็นผู้เยาว์หรือมีอายุไม่เกิน 20 บริบูรณ์ ต้องมีหนังสือยินยอมของบิดา มารดา หรือผู้ปกครอง',
      //       uploadDate: '2023-10-04T21:08:56.1',
      //       isChecked: true,
      //       enableDelete: true,
      //       isRequired: true,
      //       label: 'solo.jpg',
      //       name: 'solo.jpg',
      //       path: 'proposal/person-qualification/26834577-D2D6-4C54-BC86-471DFE989338.jpg',
      //       type: null,
      //       size: 0,
      //       status: 'ส่งแล้ว',
      //       id: '16C3C88C-B4DC-4D27-AFBC-6FE3738B27BA',
      //     },
      //     {
      //       contractFileTypeId: '13',
      //       contractFileType:
      //         'กรณีผู้รับทุนเป็นผู้เยาว์หรือมีอายุไม่เกิน 20 บริบูรณ์ ต้องมีสำเนาบัตรประจำตัวประชาชนหรือบัตรอื่นที่ทางราชการออกให้แก่ผู้ให้ความยินยอม พร้อมรับรองสำเนา',
      //       uploadDate: '2023-10-04T21:08:56.1',
      //       isChecked: true,
      //       enableDelete: true,
      //       isRequired: true,
      //       label: 'team.jpg',
      //       name: 'team.jpg',
      //       path: 'proposal/person-qualification/6BE5DD5D-F608-4E41-A569-09D4638B4AF2.jpg',
      //       type: null,
      //       size: 0,
      //       status: 'ส่งแล้ว',
      //       id: 'CCBE66ED-E5E2-4D6E-862A-4D23ECEF2681',
      //     },
      //     {
      //       contractFileTypeId: '15',
      //       contractFileType:
      //         'สำเนาบัตรประจำตัวประชาชนหรือบัตรอื่นที่ทางราชการออกให้แก่ผู้ที่จะลงนามเป็นพยานในการจัดทำข้อตกลง พร้อมรับรองสำเนา (กรณีจัดทำข้อตกลงแบบกระดาษ)',
      //       uploadDate: '2023-10-04T21:08:56.1',
      //       isChecked: true,
      //       enableDelete: true,
      //       isRequired: true,
      //       label: '220614_ประชุม M_E ประเด็นหน่วยนับ.pdf',
      //       name: '220614_ประชุม M_E ประเด็นหน่วยนับ.pdf',
      //       path: 'proposal/person-qualification/67C8F7EC-9D91-401A-9ACB-215CC926B3A3.pdf',
      //       type: null,
      //       size: 0,
      //       status: 'ส่งแล้ว',
      //       id: '4D538FE4-3944-4323-9020-E6A458A67FD9',
      //     },
      //     {
      //       contractFileTypeId: '02',
      //       contractFileType:
      //         'สำเนาหน้าบัญชีธนาคารที่แสดงเลขที่บัญชีเงินฝากออมทรัพย์ชื่อบัญชี ชื่อธนาคาร-สาขา',
      //       uploadDate: null,
      //       isChecked: false,
      //       enableDelete: true,
      //       isRequired: false,
      //       name: null,
      //       path: null,
      //       type: null,
      //       size: 0,
      //       status: 'ส่งแล้ว',
      //       id: null,
      //     },
      //   ],
      // },
    },
  },
}
